import React from 'react'
import {observer} from 'mobx-react-lite'
import {Button} from '@components/common/button/button'
import {Lang} from 'yougile-lang'
import {useImportFromFileStore} from './import-from-file-store'
import {useProcessFile} from './use-process-file/use-process-file'

export const ImportFromFilePopupFooter = observer(() => {
  const [state, store] = useImportFromFileStore()
  const {processFile} = useProcessFile()

  if (state.imported) {
    return (
      <Button onClick={() => store.close()} data-cy="import-popup__btn-close">
        {Lang.msg.close}
      </Button>
    )
  }

  const onClick = () => processFile()
  return (
    <Button
      $disabled={!state.canStartImport}
      onClick={onClick}
      data-cy="import-popup__btn-import"
    >
      {Lang.msg.importFromFile.import}
    </Button>
  )
})
